module.exports = __webpack_public_path__ + "img/logo-blanco.32fdecd2.png";